import React, { useRef } from 'react';
import { VariableSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import './VirtualList.scss';

const VirtualList = ({
  itemData,
  handleOnDeletePackages,
  deletedPackageList,
  children,
  itemHeight = 55,
  handleOnDeletePlan,
}) => {
  const { items } = itemData;
  const listRef = useRef({});
  const rowHeights = useRef({});

  const getRowHeight = (index) => {
    return rowHeights.current[index] || itemHeight;
  };

  const setRowHeight = (index, size) => {
    listRef.current.resetAfterIndex(0);
    rowHeights.current = { ...rowHeights.current, [index]: size };
  };

  const getItemKey = (index) => {
    if (items[index]?.planId && items[index]?.destination) {
      return `${items[index].planId}-${items[index].destination}`;
    } else if (items[index]?.screenId) {
      return `${items[index]?.screenId}`;
    } else if (items[index]?.packageId) {
      return `${items[index].packageId}`;
    } else if (items[index]?.pixelId) {
      return `${items[index].pixelId}`;
    } else if (items[index]?.placeDBId) {
      return `${items[index].placeDBId}`;
    }
  };
  return (
    <AutoSizer>
      {({ height, width }) => (
        <List
          className="virtual-list"
          height={height}
          itemCount={items?.length}
          itemSize={getRowHeight}
          width={width}
          overscanCount={6}
          ref={listRef}
          itemKey={getItemKey}
          itemData={{
            ...itemData,
            setRowHeight: setRowHeight,
            handleOnDeletePackages,
            deletedPackageList,
            handleOnDeletePlan,
          }}
        >
          {children}
        </List>
      )}
    </AutoSizer>
  );
};

export default VirtualList;
